<template>
  <b-navbar toggleable="md" type="dark" variant="danger">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand href="">MAADI</b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item v-if="$store.getters.hasMAAStaff" to="/">Home</b-nav-item>
        <b-nav-item-dropdown v-if="$store.getters.hasMAAStaff" text="Organizations/Members" left>
          <b-dropdown-item :to="{name: 'Organization Search Tool'}">Search Organizations</b-dropdown-item>
          <!-- <b-dropdown-item :to="{name: 'Organization Rankings'}">Organization Statistics Ranking</b-dropdown-item> -->
          <!-- <b-dropdown-item :to="{name: 'Embedded Reports'}">Engagement Dashboard</b-dropdown-item> -->
        </b-nav-item-dropdown>
        <b-nav-item-dropdown v-if="$store.getters.hasMAAStaff" text="Activities" left>
          <b-dropdown-item to="/activity/create">Create Activity</b-dropdown-item>
          <b-dropdown-item :to="{name:'Activity Search'}">Search Activities</b-dropdown-item>
          <b-dropdown-item to="/activity/printable">View Activities By Week</b-dropdown-item>
          <b-dropdown-item to="/activity/printable/organization">View Activities By Organization</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown v-if="$store.getters.hasCapabilities('communication_tools')" text="Communications" left>
          <b-dropdown-item to="/communications/external-media-assigner">External Communications Account Assigner</b-dropdown-item>
          <b-dropdown-item v-if="$store.getters.hasAdministrator" to="/communications/wordpress-tag-assigner">WordPress Tag Assigner</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown v-if="$store.getters.hasMAAStaff" text="Initiatives" left>
          <b-dropdown-item v-if="$store.getters.hasAdministrator || $store.getters.hasCapabilities('medical_alley_starts')" to="/maa-starts">Medical Alley Starts</b-dropdown-item>
          <b-dropdown-item v-if="$store.getters.hasAdministrator || $store.getters.hasCapabilities('medical_alley_starts')" to="/startup-resources">Startup Resources</b-dropdown-item>
        </b-nav-item-dropdown>
        <!-- <b-nav-item v-if="$store.getters.hasMAAStaff" text="Job Board" to="/job-board" left>Job Board</b-nav-item> -->
        <!-- <b-nav-item v-if="$store.getters.hasBOD" to="/board-of-directors">Board of Directors</b-nav-item>
        <b-nav-item-dropdown v-if="$store.getters.hasBOD && false" text="Board of Directors" left>
          <b-dropdown-item to="/board-of-directors">Dashboard</b-dropdown-item>
          <b-dropdown-item v-if="$store.getters.hasCapabilities('ngc_access') || $store.getters.hasMAAStaff" to="/board-of-directors/prospects">Prospects</b-dropdown-item>
        </b-nav-item-dropdown> -->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-on:click="(e) => { logout(e) }">Logout</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import authentication from '../Authentication'
import { mapState } from 'vuex'

export default {
  name: 'Navigation',
  computed: {
    ...mapState({
      isLoaded: state => state.getters.isLoaded
    })
  },
  methods: {
    logout (e) {
      authentication.logout()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue